import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const { login } = useAuth();
  const navigate  = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      backgroundImage: 'radial-gradient(circle at 20% 80%, #4a1d52 0%, #6A2C75 50%, #8a3d96 100%)',
    }}>
      <div style={{ width: '100%', maxWidth: 420, padding: '0 24px' }}>
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <img
            src="/logo-dasavena.png"
            alt="Dasavena"
            style={{ width: 120, height: 120, objectFit: 'contain', marginBottom: 12 }}
          />
          <p style={{ color: '#E9C16C', fontSize: 13, letterSpacing: 1 }}>
            PLATAFORMA INTERNA
          </p>
        </div>

        <div style={{ background: '#fff', borderRadius: 16, padding: '36px 32px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, color: '#6A2C75', marginBottom: 8 }}>Iniciar sesión</h2>
          <p style={{ color: '#7a6882', fontSize: 13, marginBottom: 28 }}>Ingresa tus credenciales para continuar</p>

          {error && (
            <div style={{ background: '#fdecea', color: '#c62828', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 20, borderLeft: '3px solid #c62828' }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            {[
              { label: 'CORREO ELECTRÓNICO', type: 'email', value: email, set: setEmail, placeholder: 'tu@dasavena.com' },
              { label: 'CONTRASEÑA', type: 'password', value: password, set: setPassword, placeholder: '••••••••' },
            ].map(f => (
              <div key={f.label} style={{ marginBottom: 18 }}>
                <label style={{ fontSize: 12, fontWeight: 700, color: '#7a6882', letterSpacing: 0.5, display: 'block', marginBottom: 6 }}>{f.label}</label>
                <input
                  type={f.type} value={f.value} onChange={e => f.set(e.target.value)}
                  placeholder={f.placeholder} required
                  style={{ width: '100%', padding: '11px 14px', borderRadius: 8, fontSize: 14, border: '1.5px solid #e0d5e8', outline: 'none' }}
                  onFocus={e => e.target.style.borderColor = '#6A2C75'}
                  onBlur={e => e.target.style.borderColor = '#e0d5e8'}
                />
              </div>
            ))}

            <div style={{ marginBottom: 28 }} />
            <button type="submit" disabled={loading} style={{
              width: '100%', padding: 13, borderRadius: 8, border: 'none',
              background: loading ? '#BBA4C0' : '#6A2C75', color: '#fff',
              fontSize: 15, fontWeight: 700, cursor: loading ? 'default' : 'pointer',
            }}>
              {loading ? 'Iniciando sesión...' : 'Entrar'}
            </button>
          </form>
        </div>
        <p style={{ textAlign: 'center', color: 'rgba(255,255,255,0.35)', fontSize: 11, marginTop: 24 }}>
          Dasavena Gourmet S.A. de C.V. · Uso interno
        </p>
      </div>
    </div>
  );
}
